import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import v from "../Assets/v.png"
import c from "../Assets/c.png"
import n from "../Assets/n.png"
import r from "../Assets/r.png"
import "./FinalCard.css"

// Reduced image set for better performance
const allImages = [
  require("../Assets/v1.JPG"),
  require("../Assets/c1.JPG"),
  require("../Assets/n1.JPG"),
  require("../Assets/r1.JPG"),
];

export default function FinalCard() {
  const navigate = useNavigate();
  
  return (
    <motion.div className="card-final">
      <img src={'/images/vlogo.png'} className="card-final-logo" alt="VCNR Logo" />
      <div className="vcnr-wordmark">
        <span className="vcnr-letter vcnr-v">
          <div className="vcnr-letter-container">
            <div
              className="vcnr-letter-mask vcnr-full-mask"
              style={{
                backgroundImage: `url(${allImages[0]})`,
                WebkitMaskImage: `url(${v})`,
                maskImage: `url(${v})`,
              }}
            />
          </div>
        </span>
        <span className="vcnr-letter vcnr-c">
          <div className="vcnr-letter-container">
            <div
              className="vcnr-letter-mask vcnr-full-mask"
              style={{
                backgroundImage: `url(${allImages[1]})`,
                WebkitMaskImage: `url(${c})`,
                maskImage: `url(${c})`,
              }}
            />
          </div>
        </span>
        <span className="vcnr-letter vcnr-n">
          <div className="vcnr-letter-container">
            <div
              className="vcnr-letter-mask vcnr-full-mask"
              style={{
                backgroundImage: `url(${allImages[2]})`,
                WebkitMaskImage: `url(${n})`,
                maskImage: `url(${n})`,
              }}
            />
          </div>
        </span>
        <span className="vcnr-letter vcnr-r">
          <div className="vcnr-letter-container">
            <div
              className="vcnr-letter-mask vcnr-full-mask"
              style={{
                backgroundImage: `url(${allImages[3]})`,
                WebkitMaskImage: `url(${r})`,
                maskImage: `url(${r})`,
              }}
            />
          </div>
        </span>
      </div>
      <h2 className='groups'>ENTERPRISE</h2>
      <div className="team-btn-row">
        <button className="explore-btn" style={{marginBottom: "40px"}} onClick={() => navigate("/aboutVCNR")}>Explore our Divisions</button>
      </div>
    </motion.div>
  );
} 